module.exports = __webpack_public_path__ + "static/media/dragon_boat-poster.0d7a40c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dragon_boat-poster.png
// module id = 809
// module chunks = 2